import { z } from 'zod';

import { PartyGenderSchema, PartyPfProfileFieldsSchema } from './party-pf-profile.schemas.js';
import { PartyPersonTypeSchema } from './party.schemas.js';

export const RegisterPartyBodySchema = z
  .object({
    personType: PartyPersonTypeSchema,
    isForeigner: z.boolean().default(false),
    name: z.string().trim().min(1),
    document: z.string().trim().optional(),
    legalName: z.string().trim().optional(),
    tradeName: z.string().trim().optional(),
    stateRegistration: z.string().trim().min(1).max(20).nullable().optional(),
    birthDate: z.iso.date().optional(),
    gender: PartyGenderSchema.optional(),
    enrichFromExternal: z.boolean().optional(),
  })
  .extend(PartyPfProfileFieldsSchema.shape);

export type RegisterPartyBody = z.infer<typeof RegisterPartyBodySchema>;

export const RegisterPartyResponseSchema = z.object({
  partyId: z.uuid(),
});

export type RegisterPartyResponse = z.infer<typeof RegisterPartyResponseSchema>;
